import { styled } from '@styles/stitches';

export const Container = styled('div', {
  fontFamily: '$mono',
  fontSize: 13,
  display: 'flex',
  alignItems: 'center',

  i: {
    fontSize: 'inherit',
    color: 'inherit',
    marginRight: '$space$4',
  },
});
